import { Component, AfterViewInit } from '@angular/core';
import { DgHubClientService, SettingsRequest, StoreRetracementReq, TrackedStrikeRequest } from '../Services/dg-hub-client.service';
import { MatDialog } from '@angular/material/dialog';
import { SettingsDialogComponent } from '../Dialogs/settings/settings-dialog.component';
import { DGDrawingServiceGlobal, SeriesTypes, DrawingService } from '../Services/DrawingService';
import { RetracementSettingsDialogComponent } from '../../components/retracement-settings/retracement-settings.component';
import { RetracementTabsComponent } from '../Dialogs/retracementTabs/retracementTabs.component';
import { RetracementSettings } from '../Models/RetracementSettings';
import { CookiesService } from '../Services/cookieService';
import { RetracementAccesabilityService } from '../Services/RetracementAccesability.service';
import { ViewsDialogComponent } from '../Dialogs/views/views.component';
import { ViewsEditDialogComponent } from '../Dialogs/views-edit/views-edit.component';
import * as jQuery from "jquery";
import { StrikeActionType, StrikeService } from '../Services/StrikeService/StrikeService.service';
import { StrikesSumService } from '../Services/StrikeService/StrikesSumService.service';
import { SignalService } from '../Services/SignalService/SignalService';
import { SettingsService } from '../Services/SettingsService.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements AfterViewInit {
  isExpanded = false;
  public StrikeActionType = StrikeActionType
  constructor(
    public dgCLientService: DgHubClientService,
    public dialog: MatDialog,
    private cookieService: CookiesService,
    public excludesService: RetracementAccesabilityService,
    public strikeService:StrikeService,
    public strikesSumService:StrikesSumService,
    public signalService:SignalService,
    public settingsService:SettingsService
  ) {

  }
  ngAfterViewInit(): void {
    //this.fullscreen();
    // setTimeout(()=>{

    //   jQuery("#fullscreen").on("click",function(){
    //     alert("AQQ");
    //   })
    //   jQuery("#fullscreen").trigger("click");
    // },2000)

  }


  public selectedEventsMode:number = 0;
  onValueselectedEventsMode(newValue: number) {

    this.settingsService.setAdvanceState(newValue);

    this.selectedEventsMode = Number(newValue);

    this.signalService.prepareEventsDataByState(Number(newValue))


    this.signalService.previusDayCountsData.next(Number(newValue))
     this.signalService.currentDataMode = Number(newValue);
     DGDrawingServiceGlobal.drawingService().notificationDisplayer.fullDraw();


  }
  

  onValueChange(newValue: number) {
    this.settingsService.diffValue = newValue;
  }

  onValueBarRightsChange(newValue: number) {
    this.dgCLientService.SetMinimumForRightBars(newValue).then((l)=>{
      console.log(l);
    })
    
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  openSettingsWindow() {
    const dialogRef = this.dialog.open(SettingsDialogComponent, {

    });
  }

  openRetracementWindow() {

    //if(window.innerHeight>)
    const dialogRef = this.dialog.open(RetracementTabsComponent, {
      width: 'auto',
      height: 'auto',
      maxHeight: window.innerHeight - 30 + 'px',
      maxWidth: '100vw',
    });
    //  const dialogRef = this.dialog.open(RetracementSettingsDialogComponent, {});
  }

  public show5bar:boolean = true;
  public SHow5BarF()
  {
    this.show5bar=!this.show5bar
  }
  openViewsWindow() {

    //if(window.innerHeight>)
    const dialogRef = this.dialog.open(ViewsEditDialogComponent, {
      width: 'auto',
      height: 'auto',
      maxHeight: window.innerHeight - 30 + 'px',
      maxWidth: '100vw',
      minWidth: '300px',
    });
    //  const dialogRef = this.dialog.open(RetracementSettingsDialogComponent, {});
  }

  testAddStrike()
  {
    var request = new TrackedStrikeRequest();
    request.strike="5750";
    request.side="PUT";
    this.dgCLientService.setTrackedStrike(request).then(()=>{

    })
  }
  public minBarRightsLevels = [10,20,30,40,50];

  resetToDefault() {

    let activeViewName = DGDrawingServiceGlobal.drawingService().selectedViewName;
    let req: StoreRetracementReq = {
      key: "",
      data: "",
      viewName: activeViewName
    }

    DGDrawingServiceGlobal.drawingService().loaded = false;
    DGDrawingServiceGlobal.drawingService().route.navigate(['/'], { queryParams: { viewId: null } });;
    DGDrawingServiceGlobal.drawingService().selectedViewName = null;
    DGDrawingServiceGlobal.drawingService().loadedItem = null;
    DGDrawingServiceGlobal.drawingService().dataService.getHubCLientService().StoreActiveRetracement(req);
    DGDrawingServiceGlobal.drawingService().resetToDefault(activeViewName);



  }

  public get loaded(): boolean {
    if (DGDrawingServiceGlobal.drawingService()) {
      return DGDrawingServiceGlobal.drawingService().loaded;
    }

    return false
  }


  public get timeouted()
  {
    if (DGDrawingServiceGlobal.drawingService()) {
      return DGDrawingServiceGlobal.drawingService().hideUnmute;
    }

    return false
  }

  public get loadedItem(): string {
    if (DGDrawingServiceGlobal.drawingService()) {
      return DGDrawingServiceGlobal.drawingService().loadedItem;
    }

    return ''
  }

  public get retracementAllowIntermediates() {
    //et v = this.excludesService.exludes.indexOf(SeriesTypes.INTERMEDIATE)==-1;
    return this.excludesService.allowType(SeriesTypes.INTERMEDIATE);
  }

  enableIntermediates() {
    if (this.retracementAllowIntermediates) {
      this.excludesService.addType(SeriesTypes.INTERMEDIATE)
    }
    else {
      this.excludesService.removeType(SeriesTypes.INTERMEDIATE)
    }
  }

  logout() {
    this.cookieService.setCookie("_tk", '', 1, "/");
    window.location.href = "/";
    console.log("sitereload_type0");
  }

  test() {
    this.dgCLientService.testAction();
   // DGDrawingServiceGlobal.drawingService().loadView("new45");
  }

  elem;
  ngOnInit() {
    this.elem = document.documentElement;
  }

  public isFullScreen: boolean = false;
  fullscreen() {

    if( DGDrawingServiceGlobal.drawingService())
    {
      if(DGDrawingServiceGlobal.drawingService().annotations)
      {
         DGDrawingServiceGlobal.drawingService().annotations.activatedPriceLineTracker = false;
      }

    }



    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
    this.isFullScreen = true;

    setTimeout(()=>{
          this.strikeService.updateCanvasLocation();
          this.strikesSumService.updateCanvasLocation();
    },100)

  }

  closeFullscreen() {
    DGDrawingServiceGlobal.drawingService().annotations.activatedPriceLineTracker = false;
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) { /* Firefox */
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) { /* Chrome, Safari and Opera */
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) { /* IE/Edge */
      (document as any).msExitFullscreen();
    }
    this.isFullScreen = false;
  }

  selectView() {
    DGDrawingServiceGlobal.drawingService().annotations.activatedPriceLineTracker = false;
    const dialogRef = this.dialog.open(ViewsDialogComponent, {
      width: 'auto',
      height: 'auto',
      maxHeight: window.innerHeight - 30 + 'px',
      maxWidth: '100vw',
    });
  }

  private _tracerState: boolean = true;
  public get tracerState(): boolean {
    return this._tracerState;
  }
  public set tracerState(value: boolean) {
    this._tracerState = value;
  }

  private _expandMenuPanel: boolean = false;
  public get expandMenuPanel(): boolean {
    return this._expandMenuPanel;
  }
  public set expandMenuPanel(value: boolean) {
    this._expandMenuPanel = value;
  }


  public get clicked(): boolean {
    return  DGDrawingServiceGlobal.drawingService().muted;
  }

  public playForUnmute() {
    DGDrawingServiceGlobal.drawingService().annotations.activatedPriceLineTracker = false;
    let buyAudio = new Audio();
    let sellAudio = new Audio();

    buyAudio.src = "bear3.wav";
    buyAudio.load();

    sellAudio.src = "bull.mp3";
    sellAudio.load();
    buyAudio.volume = 0;
    buyAudio.play();
   // buyAudio.pause()

    sellAudio.volume=0;
    sellAudio.play();
    //sellAudio.pause();
    DGDrawingServiceGlobal.drawingService().muted = false;
    this.fullscreen();
  }

  lastWaveTrackerState() {
    DGDrawingServiceGlobal.drawingService().annotations.activatedPriceLineTracker = false;
    DGDrawingServiceGlobal.drawingService().isLastWaveTracker = !DGDrawingServiceGlobal.drawingService().isLastWaveTracker;
    DGDrawingServiceGlobal.drawingService().annotations.globalLastWaveTracker.update();
    this.tracerState = DGDrawingServiceGlobal.drawingService().isLastWaveTracker;
  }

  addPriceLine() {
    DGDrawingServiceGlobal.drawingService().annotations.activatedPriceLineTracker = !DGDrawingServiceGlobal.drawingService().annotations.activatedPriceLineTracker;
  }

  public get alertsEnabled():boolean
  {
    return DGDrawingServiceGlobal.drawingService().alertsEnabled;
  }

  changeMagnituderAlertsState() {
    DGDrawingServiceGlobal.drawingService().annotations.activatedPriceLineTracker = false;

    DGDrawingServiceGlobal.drawingService().alertsEnabled = !DGDrawingServiceGlobal.drawingService().alertsEnabled;

    DGDrawingServiceGlobal.drawingService().alertsForegroundMagnituder.isAlertActive = this.alertsEnabled;
    DGDrawingServiceGlobal.drawingService().alertsBackgroundMagnituder.isAlertActive = this.alertsEnabled;

    DGDrawingServiceGlobal.drawingService().updateMangituderState();
  }

  compute() {
    DGDrawingServiceGlobal.drawingService().waveComputer.renderPernament();
  }

  public get isPricelIneDrawActive(): boolean {
    if (DGDrawingServiceGlobal.drawingService().annotations != undefined) {
      return DGDrawingServiceGlobal.drawingService().annotations.activatedPriceLineTracker;
    }

    return false;
  }

  public clearRetracements()
  {
    DGDrawingServiceGlobal.drawingService().activeRetracements.removeVisibleRetracement();
  }


  public hideRightbar()
  {
    this.strikesSumService.rightBarsEnabled = !this.strikesSumService.rightBarsEnabled;
  }
}
